import { twMerge } from 'tailwind-merge';
import { FishingWaterRegionFields, PlaceRegionFields } from '../../../generated/graphql';
import { ExternalLink } from '../../Clickables/ExternalLink/ExternalLink';
import { Heading } from '../../Heading/Heading';
import { ArrowUpRightIcon } from '../../Icons/ArrowUpRightIcon';
import { Text } from '../../Text/Text';
import licenseIcon from '../assets/LicenseIcon.png';
import { firstNonEmpty } from '@lib/strings/firstNonEmpty';
import { NextImageWrapper } from '../../NextImage/NextImageWrapper';

export interface ILicenseSectionProps {
  region: FishingWaterRegionFields | PlaceRegionFields;
  className?: string;
  licenseUrl?: string;
}

export const LicenseSection = ({ region, className, licenseUrl }: ILicenseSectionProps) => {
  const url = licenseUrl ?? region.licenseInfoUrl;
  return url ? (
    <div
      className={twMerge(
        'bg-lake-fog flex flex-row items-center gap-4 rounded-lg p-4 sm:mx-auto sm:max-w-md sm:gap-6 sm:p-6 md:p-8',
        className,
      )}
    >
      <NextImageWrapper
        wrapperClassName=""
        customPlaceholderClassName=""
        imageClassName="w-[70px] h-[70px] aspect-square object-contain"
        alt="License Icon"
        src={licenseIcon}
      />
      <div className="flex flex-col gap-1 sm:gap-2">
        <Heading as="span" variant="sm" className="mb-0">
          Local laws and licenses
        </Heading>
        <Text variant="sm" className="mb-0">
          {firstNonEmpty(region.localName, region.name)} fishing license
        </Text>
        <ExternalLink
          href={url}
          className="heading-text-xxs constantSize font-heading text-trench flex items-center font-medium!"
          target="_blank"
          variant="textNone"
        >
          Get license <ArrowUpRightIcon />
        </ExternalLink>
      </div>
    </div>
  ) : (
    <></>
  );
};
